import axios from 'axios';
import authHeader from '../auth-header';

import tokenHeader from '../token-header';

// const API_URL = 'https://localhost:9090/api/all/';
import baseUrl from '../base-url';

const API_URL = baseUrl()+"/api/all/";

const getPetugasIapi = 'petugas-iapi';
const getDetailPetugasIapi = 'petugas-iapi/';
const getPetugasIapiTidakAktif = 'petugas-iapi';
const postPetugasIapiUrl = 'petugas-iapi';
const putPetugasIapi = 'petugas-iapi/';
const deletePetugasIapi = 'petugas-iapi/';
const exportPetugasIapi = 'petugas-iapi-export';

class PetugasIapiService {
    getPetugasIapi(currentPage) {
        return axios.get(
            API_URL + getPetugasIapi + '?page=' + currentPage + 'size=5',
            {
                headers: authHeader()
            });
    }

    getPetugasIapiAktif(currentPage, pageSize, filter) {
        return axios.get(            
            API_URL + getPetugasIapi + '?status=1' + '&pageNo=' + currentPage + '&pageSize=' + pageSize + '&sortBy=id' + '&filter=' + filter,
            {
                headers: authHeader()
            }
        );
    }

    getPetugasIapiTidakAktif(currentPage, pageSize, filter) {
        return axios.get(            
            API_URL + getPetugasIapiTidakAktif + '?pageNo=' + currentPage + '&pageSize=' + pageSize + '&sortBy=id' + '&filter=' + filter + '&status=0',
            {
                headers: authHeader()
            }
        );
    }

    postPetugasIapi(formData) {        
        try {
            let form = new FormData();
            form.append('username', formData.username);
            form.append('name', formData.name);
            form.append('email', formData.email);
            form.append('password', formData.password);
            form.append('noTelephone', formData.noTelephone);
            form.append('status', formData.status);            
            form.append('tipePetugas', 'iapi');                          
            form.append('divisi.idDivisi', formData.idDivisi);                                
            form.append('cabang.idCabang', formData.idCabang);        
            
            
            if (typeof formData.foto !== 'undefined') {
                form.append('foto', formData.foto);
            }
            
            if(formData.roles && formData.roles.length > 0) {                
                for (let i = 0; i < formData.roles.length; i++) {
                    const role = formData.roles[i];
                    form.append(`roles[${i}].roleName`, role.nama_role);
                    form.append(`roles[${i}].statusCreate`, role.status_create);
                    form.append(`roles[${i}].statusRead`, role.status_read);
                    form.append(`roles[${i}].statusUpdate`, role.status_update);
                    form.append(`roles[${i}].statusDelete`, role.status_delete);
                    form.append(`roles[${i}].statusExportPdf`, true);
                    form.append(`roles[${i}].statusExportExcel`, role.status_export_excel);
                }
            }            
            
            return axios.post(API_URL + postPetugasIapiUrl, form, {
                headers: {
                    'Content-Type': 'multipart/form-data', 
                    'Authorization': tokenHeader()
                }
            });
        } catch (error) {
            // comment console console.log(error)
        }
    }

    getDetailPetugasIapi(id) {
        return axios.get(API_URL + getDetailPetugasIapi + id, {
            headers: authHeader()
        });
    }

    putPetugasIapi(formData) {
        try {
            let form = new FormData();
            form.append('username', formData.username);
            form.append('name', formData.name);
            form.append('email', formData.email);
            form.append('password', formData.password);
            form.append('noTelephone', formData.noTelephone);
            form.append('status', formData.status);
            form.append('tipePetugas', 'iapi');
            form.append('divisi.idDivisi', formData.idDivisi);                                
            form.append('cabang.idCabang', formData.idCabang);                                  
            
            if(formData.foto) {
                form.append('foto', formData.foto);
            }

            if(formData.roles && formData.roles.length > 0) {                
                for (let i = 0; i < formData.roles.length; i++) {
                    const role = formData.roles[i];
                    // comment console console.log(role)
                    form.append(`roles[${i}].roleName`, role.nama_role);
                    form.append(`roles[${i}].statusCreate`, role.status_create);
                    form.append(`roles[${i}].statusRead`, role.status_read);
                    form.append(`roles[${i}].statusUpdate`, role.status_update);
                    form.append(`roles[${i}].statusDelete`, role.status_delete);
                    form.append(`roles[${i}].statusExportPdf`, true);
                    form.append(`roles[${i}].statusExportExcel`, role.status_export_excel);
                }
            }            
            
            return axios.put(API_URL + putPetugasIapi + formData.id, form, {
                headers: {
                    'Content-Type': 'multipart/form-data', 
                    'Authorization': tokenHeader()
                }
            });
        } catch (error) {
            // comment console console.log(error)
        }
    }

    deletePetugasIapi(formData) {
        var headers = authHeader();

        return axios
            .delete(
                API_URL + deletePetugasIapi + formData.id,
                { headers: authHeader() }
            );
    }

    exportPetugasIapiAktif() {
        return axios.get(API_URL + exportPetugasIapi + '?status=1', {
            headers: authHeader(),
            responseType: 'blob'
        });
    }

    exportPetugasIapiTidakAktif() {
        return axios.get(API_URL + exportPetugasIapi + '?status=0', {
            headers: authHeader(),
            responseType: 'blob'
        });
    }    
}

export default new PetugasIapiService();